
import React from 'react';
import { FolderClosed, FolderOpen } from 'lucide-react';

const FolderGrid = ({ card, isSelected, onSelect }) => {
  return (
    <div
      key={card.id}
      onClick={onSelect}
      className={`p-6 border rounded-lg shadow-md flex flex-col items-center h-48 justify-center transition-all cursor-pointer mt-4
        ${isSelected ? "bg-red-500 text-white" : "bg-white text-gray-800"}`}
    >
      <div className={`text-2xl mb-2 ${isSelected ? "text-white" : "text-red-500"}`}>
        {isSelected ? <FolderOpen /> : <FolderClosed />}
      </div>
      <span className="text-lg font-semibold">{card.name || card.label}</span>
    </div>
  );
};

export default FolderGrid;
